import React, {memo, PropsWithChildren, ReactNode} from "react"
import styled from "styled-components"

interface AdministrationLayoutProps extends PropsWithChildren {
  breadcrumb: ReactNode
}

// eslint-disable-next-line react/display-name
const AdministrationLayout = memo<AdministrationLayoutProps>(({breadcrumb, children}) => {
  return <DocContainer>
    <Content>
      {breadcrumb}
      <StyledRow>
        {children}
      </StyledRow>
    </Content>
  </DocContainer>
})

export default AdministrationLayout

export const InformationsContainer = styled.div`
  width: 40%;
  @media (max-width: 1600px) {
    width: 100%;
    min-height: 40%;
    max-height: 40%;
  }
`

export const ContentContainer = styled.div`
  width: 60%;
  @media (max-width: 1600px) {
    width: 100%;
    flex-grow: 1;
    min-height: 0;
  }
`

const StyledRow = styled.div`
  display: flex;
  flex-grow: 1;
  min-height: 0;
  gap: 24px;
  flex-direction: row;
  overflow: hidden;

  @media (max-width: 1600px) {
    flex-direction: column;
  }
`

const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  overflow: hidden;

  @media (max-width: 1200px) {
    gap: 10px;
  }
`

const DocContainer = styled.div`
  border-left: 1px solid var(--border-color-base);
  padding: 40px;
  margin: 0;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`